export enum Pinchpoints {
  DashboardSettings = 'DashboardSettings',
  Footer = 'Footer',
  HomePage = 'HomePage',
  MobileMenu = 'MobileMenu',
  OnboardingTutorial = 'OnboardingTutorial',
  OnboardingAccount = 'OnboardingAccount',
  OnboardingBanner = 'OnboardingBanner',
  OnboardingCard = 'OnboardingCard',
  OnboardingOverview = 'OnboardingOverview',
  OnboardingSnoozingModal = 'OnboardingSnoozingModal',
  RedeemPageCannotSelfRedeem = 'RedeemPageCannotSelfRedeem',
  RedeemPageFormerSubscriber = 'RedeemPageFormerSubscriber',
  RedeemPageKeyClaimed = 'RedeemPageKeyClaimed',
  SettingsHighlightToTranslate = 'SettingsHighlightToTranslate',
  SettingsPage = 'SettingsPage',
  PremiumPromo = 'PremiumPromo',
}

export default Pinchpoints;
